interface Props {
  size?: number;
  animated?: boolean;
}

export default function RotatePlayLogo({ size = 36, animated = true }: Props) {
  const brown = '#6B3520';

  return (
    <svg
      viewBox="0 0 220 220"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0 }}
    >
      {/* Background */}
      <circle cx="110" cy="110" r="110" fill="#1e7a47" />
      <circle cx="110" cy="110" r="95" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="2" />

      {/* Rotation ring — spins when animated */}
      <g transform="translate(110,110)">
        <g style={animated ? { animation: 'spin-logo 4s linear infinite', transformOrigin: '0 0' } : {}}>
          {/* Arc 1: 12-o'clock CW 120° */}
          <path d="M 0 -80 A 80 80 0 0 1 69.3 40"
            fill="none" stroke="rgba(255,255,255,0.52)" strokeWidth="10" strokeLinecap="round" />
          <g transform="translate(69.3,40) rotate(210)">
            <polygon points="0,-11 8,8 -8,8" fill="rgba(255,255,255,0.52)" />
          </g>
          {/* Arc 2: 6-o'clock CW 120° */}
          <path d="M 0 80 A 80 80 0 0 1 -69.3 -40"
            fill="none" stroke="rgba(255,255,255,0.52)" strokeWidth="10" strokeLinecap="round" />
          <g transform="translate(-69.3,-40) rotate(30)">
            <polygon points="0,-11 8,8 -8,8" fill="rgba(255,255,255,0.52)" />
          </g>
        </g>
      </g>

      {/* Paddle — upright, rotated 20° CW around throat (90,95) */}
      <g transform="translate(90,95) rotate(20) translate(-90,-95)">
        {/* Full silhouette: head + throat + handle. White stroke behind brown fill = glow outline */}
        <path
          d="M 65 55 Q 65 35 90 35 Q 115 35 115 55
             L 115 88 Q 115 98 103 100
             L 103 145 Q 103 152 90 152 Q 77 152 77 145
             L 77 100 Q 65 98 65 88 Z"
          fill={brown}
          stroke="white"
          strokeWidth="7"
          strokeLinejoin="round"
          style={{ paintOrder: 'stroke fill' }}
        />
        {/* Inner face ring */}
        <path
          d="M 71 57 Q 71 41 90 41 Q 109 41 109 57 L 109 86 Q 109 92 90 92 Q 71 92 71 86 Z"
          fill="none" stroke="white" strokeWidth="3"
        />
        {/* Grip lines */}
        <line x1="78" y1="110" x2="102" y2="110" stroke="white" strokeWidth="2.5" strokeOpacity="0.55" />
        <line x1="78" y1="118" x2="102" y2="118" stroke="white" strokeWidth="2.5" strokeOpacity="0.55" />
        <line x1="78" y1="126" x2="102" y2="126" stroke="white" strokeWidth="2.5" strokeOpacity="0.55" />
        <line x1="78" y1="134" x2="102" y2="134" stroke="white" strokeWidth="2.5" strokeOpacity="0.55" />
      </g>

      {/* Ball — brown ring outline + yellow fill */}
      <circle cx="148" cy="128" r="30" fill={brown} />
      <circle cx="148" cy="128" r="26" fill="#F5D800" />
      {/* Holes */}
      <ellipse cx="139" cy="120" rx="3.5" ry="4"   fill={brown} />
      <ellipse cx="148" cy="118" rx="3.5" ry="3"   fill={brown} />
      <ellipse cx="157" cy="120" rx="3.5" ry="4"   fill={brown} />
      <ellipse cx="137" cy="129" rx="3"   ry="3.5" fill={brown} />
      <ellipse cx="148" cy="128" rx="3"   ry="3"   fill={brown} />
      <ellipse cx="159" cy="129" rx="3"   ry="3.5" fill={brown} />
      <ellipse cx="140" cy="138" rx="3.5" ry="4"   fill={brown} />
      <ellipse cx="149" cy="139" rx="3.5" ry="3"   fill={brown} />

      {/* Motion swoosh lines */}
      <path d="M 112 142 Q 127 146 150 143" stroke={brown} strokeWidth="3.5" fill="none" strokeLinecap="round" />
      <path d="M 110 150 Q 127 154 152 150" stroke={brown} strokeWidth="3.5" fill="none" strokeLinecap="round" />
      <path d="M 108 157 Q 125 162 152 158" stroke={brown} strokeWidth="3.5" fill="none" strokeLinecap="round" />
    </svg>
  );
}
